// Function to normalize carrier names for display
export function normalizeCarrier(carrier: string): string {
  const lower = carrier.toLowerCase();
  let normalized = '';
  if (lower.includes('fedex')) normalized = 'fedex';
  else if (lower.includes('ups')) normalized = 'ups';
  else if (lower.includes('dhl')) normalized = 'dhl';
  else if (lower.includes('canpar')) normalized = 'canpar';
  else if (lower.includes('purolator')) normalized = 'purolator';
  else {
    // For carriers like "FedEx Ground", extract the base carrier name
    const parts = carrier.split(' ');
    if (parts.length > 1) {
      const baseCarrier = parts[0];
      const baseLower = baseCarrier.toLowerCase();
      if (baseLower === 'fedex') normalized = 'fedex';
      else if (baseLower === 'ups') normalized = 'ups';
      else if (baseLower === 'dhl') normalized = 'dhl';
      else if (baseLower === 'canpar') normalized = 'canpar';
      else if (baseLower === 'purolator') normalized = 'purolator';
      else normalized = carrier.toLowerCase(); // fallback to lowercase
    } else {
      normalized = carrier.toLowerCase(); // fallback to lowercase
    }
  }

  // Return capitalized for display
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
}

// Function to get tracking link for a carrier
export function getTrackingLink(trackingNumber: string, carrier: string): string {
  const normalized = normalizeCarrier(carrier).toLowerCase();
  switch (normalized) {
    case 'ups':
      return `https://www.ups.com/track?loc=en_US&tracknum=${trackingNumber}`;
    case 'dhl':
      return `https://www.dhl.com/us-en/home/tracking/tracking-ecommerce.html?tracking-id=${trackingNumber}`;
    case 'fedex':
      return `https://www.fedex.com/apps/fedextrack/?action=track&action=track&tracknumbers=${trackingNumber}`;
    case 'canpar':
      return `https://www.canpar.com/en/tracking/track.htm?barcode=${trackingNumber}`;
    case 'purolator':
      return `https://www.purolator.com/en/shipping/tracker?pin=${trackingNumber}`;
    default:
      return '#';
  }
}

// Function to get CSS class for carrier styling
export function getCarrierClass(carrierName?: string): string {
  if (!carrierName) return 'rate-card-default';

  const carrier = carrierName.toLowerCase();
  if (carrier.includes('ups')) return 'rate-card-ups';
  if (carrier.includes('dhl')) return 'rate-card-dhl';
  if (carrier.includes('fedex')) return 'rate-card-fedex';
  if (carrier.includes('canpar')) return 'rate-card-canpar';
  if (carrier.includes('purolator')) return 'rate-card-purolator';

  return 'rate-card-default';
}